<div mat-dialog-content mat-dialog-close>
  <app-events-list [events]="data.events"></app-events-list>
</div>
